var exports = {
  "nM": "GuildBoostGoalRow.module__row___bzg0MU",
  "wk": "GuildBoostGoalRow.module__goal___bzg0MU",
  "hw": "GuildBoostGoalRow.module__progressGroup___bzg0MU",
  "u4": "GuildBoostGoalRow.module__track___bzg0MU",
  "GS": "GuildBoostGoalRow.module__fill___bzg0MU",
  "NR": "GuildBoostGoalRow.module__boost-progress-enter___bzg0MU",
  "lO": "GuildBoostGoalRow.module__cta___bzg0MU",
  "jP": "GuildBoostGoalRow.module__tooltipPerks___bzg0MU",
};

module.exports = exports;
